
import { useEffect, useRef } from "react";
import { AnalyticsService } from "@/services/analyticsService";

interface UseProviderImpressionProps {
  providerId: string;
  pageType: 'explore' | 'category' | 'search' | 'home' | 'favorites';
  searchQuery?: string;
  category?: string;
  enabled?: boolean;
}

export const useProviderImpression = ({
  providerId,
  pageType,
  searchQuery,
  category,
  enabled = true
}: UseProviderImpressionProps) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!enabled || hasTracked.current || !elementRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasTracked.current) {
            hasTracked.current = true;
            AnalyticsService.trackProviderImpression(providerId, {
              pageType,
              searchQuery,
              category
            });
          }
        });
      },
      {
        threshold: 0.5, // Track when 50% of the card is visible
        rootMargin: "0px"
      }
    );

    observer.observe(elementRef.current);

    return () => {
      observer.disconnect();
    };
  }, [providerId, pageType, searchQuery, category, enabled]);

  return elementRef;
};
